import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
// import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";
const EmployeeSettingEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const [farmLists, setFarmLists] = useState([]);
   const [permission, setPermission] = useState({});
 
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const formik = useFormik({
    initialValues: {
      id: value.id,
      gross_hourly_wage: value.gross_hourly_wage,
      cnss_rate: value.cnss_rate,
      amo_rate: value.amo_rate,
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/employee-setting/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Setting");
           if (response.data.code === 200) {
             //setBackendSuccess(response.data.message);
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/employee-setting";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(442)); 
console.log(permission);

  
    axios
      .get(`/employee-setting/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         setValue(response.data.data.setting);
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  
 

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Edit Employe Setting</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/employee-setting">Employe Setting</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Employe Setting Update</h4>
                     {permission && permission.update === 1 && ( 
            <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        
                      
                      <div className="row">

                    
                       <div className="col-md-6">
                          <div className="form-group">
                              <label>gross_hourly_wage</label>
                              <input
                                type="text"
                                onKeyPress={(event) => {
                                  // Allow only numbers (0-9)
                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                    event.preventDefault();
                                  }
                                }}
                                name="gross_hourly_wage"
                                value={formik.values.gross_hourly_wage}
                                className='form-input form-control'
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.gross_hourly_wage && (
                                    <span className="form-error mt-1">
                                      {backendErrors.gross_hourly_wage}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       <div className="col-md-6">
                          <div className="form-group">
                              <label>cnss_rate</label>
                              <input
                                type="text"
                                onKeyPress={(event) => {
                                  // Allow only numbers (0-9)
                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                    event.preventDefault();
                                  }
                                }}
                                name="cnss_rate"
                                value={formik.values.cnss_rate}
                                className='form-input form-control'
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.cnss_rate && (
                                    <span className="form-error mt-1">
                                      {backendErrors.cnss_rate}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                     
                       <div className="col-md-6">
                          <div className="form-group">
                              <label>amo_rate</label>
                              <input
                                type="text"
                                onKeyPress={(event) => {
                                  // Allow only numbers (0-9)
                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                    event.preventDefault();
                                  }
                                }}
                                name="amo_rate"
                                value={formik.values.amo_rate}
                                className='form-input form-control'
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.amo_rate && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amo_rate}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                     

                        </div>
                       
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Update Setting
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                     )}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeSettingEdit;
